import React, { useEffect,useState } from "react";

const faqData = [
  {
    question: "What If I Am Unable to Attend the Masterclass Live?",
    answer:
      'If for any reason you are not able to attend the masterclass, drop us an email at “support@billionaireaniket.com” up to 15 minutes before the masterclass starts & we will reserve your seat for the next masterclass but the reason should be genuine and please note that I can do it only once.',
  },
  {
    question: "How Can I Join the Masterclass?",
    answer:
      "Once you book the ticket for a masterclass, you can join the exclusive WhatsApp Group. You’ll get the reminders and link to join the masterclass. You can also check your email for the link.",
  },
  {
    question: "Can I Ask Questions During the Masterclass?",
    answer:
      "Yes! You can ask your questions during the masterclass and as a bonus for booking a ticket, you will get a CHANCE to have a direct conversation with me at the end.",
  },
  {
    question: "Where Will I be Getting My Bonuses?",
    answer:
      "You’ll also receive all the bonuses on the next page. Additionally, I’ll send bonuses to your email address. You can check your email inbox. In case it is not in the inbox, you can check your spam/junk folder.",
  },
  {
    question: "What Should Do If I Have Any Additional Queries?",
    answer:
      "Simply send an email to “support@billionaireaniket.com” and you will get the response in the next 24 hours.",
  },
];

const FaqAccordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      const checkMobile = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);

  return (
    <div style={{ background: "#f1e7e7", width: "100%", padding: "50px 0",marginBottom:"0px" }}>
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "0 20px",
          fontFamily: "outfit, sans-serif",
          color: "#000",
          
        }}
      >
        <h2
          style={{
            fontSize: "30px",
            fontWeight: "700",
            color: "#333333",
            textAlign: "center",
            marginBottom: "40px",
            fontWeight:"900"
          }}
        >
          Frequently Asked Questions.
        </h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            style={{
              background: activeIndex === index ? "#f7c53f" : "#fff",
              marginBottom: "12px",
              borderRadius: "8px",
              overflow: "hidden",
              transition: "all 0.3s ease",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              border: "1px solid #ddd",
            }}
          >
            <div
              onClick={() => toggleIndex(index)}
              style={{
                cursor: "pointer",
                padding: "16px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              <span>{item.question}</span>
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#000",
                  marginLeft: "10px",
                }}
              >
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>

            {activeIndex === index && (
              <div
                style={{
                  background: "#fff",
                  padding: "16px 20px",
                  fontSize: "13px",
                  lineHeight: "1.5",
                  borderTop: "1px solid #ccc",
                }}
              >
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
      {/* CTA Button */}
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <button style={{
            background: 'linear-gradient(49.12deg, #ffc74b 0, #e39600 22%)',
            color: 'white',
            fontSize: isMobile ? '18px' : '20px',
            padding: isMobile ? '10px 40px' : '25px 80px',
            border: 'none',
            borderRadius: '20px',
            fontWeight: 'bold',
            cursor: 'pointer',
            width: isMobile ? '90%' : 'auto',
          }}>
            Join The 2 Day Workshop for ₹199 &nbsp;
            <span style={{ textDecoration: 'line-through', opacity: 0.8 }}>₹999</span>
          </button>
          <p style={{
            marginTop: '10px',
            color: 'black',
            fontSize: '16px',
            fontFamily: 'outfit,sans-serif',
            fontStyle: 'italic'
          }}>
           <span style={{fontWeight:'600'}}> Registrations End on </span> <span style={{ fontWeight: 'bold', color: 'red' }}>11 JUL</span> <br />
            <span style={{fontWeight:'600'}}>100% </span>मनी बॅक गॅरंटी | समाधानी नसल्यास
          </p>
        </div>
    </div>
  );
};

export default FaqAccordion;
